var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEbene2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 108,
    viewBox: "0 0 80 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    clipPath: "url(#clip0_81_36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.1933 0.435547H6.80665C3.04744 0.435547 0 3.48723 0 7.25167V100.286C0 104.051 3.04744 107.102 6.80665 107.102H73.1933C76.9526 107.102 80 104.051 80 100.286V7.25167C80 3.48723 76.9526 0.435547 73.1933 0.435547Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40 9.90674L39.1222 12.6147H36.2797L38.5787 14.287L37.7009 16.9933L40 15.321L42.2991 16.9933L41.4213 14.287L43.7204 12.6147H40.8795L40 9.90674Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.8795 59.625L40 56.917L39.1222 59.625H36.2797L38.5787 61.2973L37.7009 64.0052L40 62.3313L42.2991 64.0052L41.4213 61.2973L43.7204 59.625H40.8795Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5283 38.8274L18.8274 40.4997L17.9496 37.7933L20.2487 36.1194H17.4061L16.5283 33.4131L15.6489 36.1194H12.8063L15.1071 37.7933L14.2276 40.4997L16.5283 38.8274Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.9845 15.763H29.142L28.2642 13.0566L27.3864 15.763H24.5438L26.8429 17.4353L25.9651 20.1432L28.2642 18.4693L30.5633 20.1432L29.6855 17.4353L31.9845 15.763Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.6723 21.6592L18.7945 24.3672H15.9519L18.251 26.0394L17.3732 28.7474L19.6723 27.0735L21.9713 28.7474L21.0935 26.0394L23.3926 24.3672H20.5501L19.6723 21.6592Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.5501 47.8714L19.6723 45.165L18.7945 47.8714H15.9519L18.251 49.5453L17.3732 52.2516L19.6723 50.5793L21.9713 52.2516L21.0935 49.5453L23.3926 47.8714H20.5501Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M29.142 56.4754L28.2642 53.769L27.3864 56.4754H24.5438L26.8429 58.1493L25.9651 60.8556L28.2642 59.1833L30.5633 60.8556L29.6855 58.1493L31.9845 56.4754H29.142Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M67.1937 36.1194H64.3511L63.4733 33.4131L62.5955 36.1194H59.753L62.0521 37.7933L61.1743 40.4997L63.4733 38.8274L65.7724 40.4997L64.8946 37.7933L67.1937 36.1194Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.7375 13.0566L50.8581 15.763H48.0155L50.3162 17.4353L49.4368 20.1432L51.7375 18.4693L54.0366 20.1432L53.1571 17.4353L55.4579 15.763H52.6153L51.7375 13.0566Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M58.9064 26.0394L58.0286 28.7474L60.3277 27.0735L62.6284 28.7474L61.749 26.0394L64.0497 24.3672H61.2072L60.3277 21.6592L59.4499 24.3672H56.6074L58.9064 26.0394Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M61.2072 47.8714L60.3277 45.165L59.4499 47.8714H56.6074L58.9064 49.5453L58.0286 52.2516L60.3277 50.5793L62.6284 52.2516L61.749 49.5453L64.0497 47.8714H61.2072Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M52.6153 56.4754L51.7375 53.769L50.8581 56.4754H48.0155L50.3162 58.1493L49.4368 60.8556L51.7375 59.1833L54.0366 60.8556L53.1571 58.1493L55.4579 56.4754H52.6153Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M17.9908 80.0519C17.9908 76.6678 20.1268 74.2583 23.5853 74.2583C26.4855 74.2583 28.4783 75.9817 28.9559 78.8068H26.9961C26.6453 77.0504 25.3541 75.9817 23.5853 75.9817C21.3538 75.9817 19.9522 77.5451 19.9522 80.0519C19.9522 82.5587 21.3702 84.17 23.5063 84.17C25.2437 84.17 26.3752 83.037 26.3752 81.4405H23.0122V79.8293H26.8215C28.2559 79.8293 29.0366 80.5467 29.0366 81.904V85.6707H27.3468V82.2552H27.3156C27.0916 84.4899 25.6258 85.9099 23.3152 85.9099C20.191 85.9099 17.9924 83.6125 17.9924 80.0536L17.9908 80.0519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M31.059 85.6707V74.499H35.0758C38.391 74.499 40.7016 76.765 40.7016 80.0205C40.7016 83.276 38.391 85.6707 35.0758 85.6707H31.059ZM32.971 83.9473H35.2026C37.2744 83.9473 38.7253 82.336 38.7253 80.0205C38.7253 77.8337 37.2744 76.2224 35.2026 76.2224H32.971V83.9473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M42.5165 85.6707V74.499H48.1736C50.4529 74.499 51.8396 76.0146 51.8396 78.0102C51.8396 80.2597 50.2783 81.6334 48.1736 81.6334H44.4285V85.6707H42.5165ZM44.4302 79.9084H48.0797C49.2754 79.9084 49.8963 79.0145 49.8963 78.0085C49.8963 77.0025 49.1799 76.2208 48.0797 76.2208H44.4302V79.9067V79.9084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M53.5606 85.6707V74.499H59.0119C61.1314 74.499 62.5972 75.792 62.5972 77.6589C62.5972 79.031 61.6255 80.164 60.1433 80.5483C60.8762 80.6918 61.4015 81.1387 61.6733 81.8248L63.1077 85.6707H61.0672L59.776 82.143C59.6163 81.6961 59.2507 81.457 58.7401 81.457H55.4727V85.6707H53.5606ZM55.4727 79.7649H58.9147C60.0939 79.7649 60.6999 78.9189 60.6999 77.9458C60.6999 76.925 59.9984 76.2224 58.9147 76.2224H55.4727V79.7649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M18.4074 92.8204C18.4074 91.2487 19.4005 90.1289 21.0145 90.1289C22.3617 90.1289 23.2889 90.9156 23.5095 92.2432H22.5988C22.4358 91.4268 21.8363 90.9304 21.0145 90.9304C19.9704 90.9304 19.3182 91.6643 19.3182 92.822C19.3182 93.9798 19.9704 94.7351 21.0145 94.7351C21.8511 94.7351 22.4358 94.2535 22.5988 93.4289H23.5095C23.2724 94.778 22.3699 95.5432 21.0145 95.5432C19.4219 95.5432 18.4074 94.4449 18.4074 92.822V92.8204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M24.1172 92.8204C24.1172 91.2487 25.1103 90.1289 26.7012 90.1289C28.2922 90.1289 29.3001 91.1893 29.3001 92.8204C29.3001 94.4514 28.3004 95.5416 26.7012 95.5416C25.1021 95.5416 24.1172 94.4729 24.1172 92.8204ZM28.3975 92.8204C28.3975 91.6627 27.7388 90.9288 26.7012 90.9288C25.6637 90.9288 25.0198 91.6627 25.0198 92.8204C25.0198 93.9781 25.6719 94.7335 26.7012 94.7335C27.7306 94.7335 28.3975 93.9913 28.3975 92.8204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M30.1367 95.4309V90.2393H31.2336L32.8558 94.3622L34.4697 90.2393H35.5666V95.4309H34.6772V91.7747L33.2411 95.4309H32.4638L31.0277 91.7829V95.4309H30.1384H30.1367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M36.6453 95.4309V90.2393H39.2737C40.3327 90.2393 40.9766 90.9435 40.9766 91.8703C40.9766 92.9159 40.2503 93.5541 39.2737 93.5541H37.5329V95.4309H36.6436H36.6453ZM37.5346 92.7543H39.2309C39.7859 92.7543 40.0758 92.3387 40.0758 91.872C40.0758 91.4052 39.7431 91.0408 39.2309 91.0408H37.5346V92.7543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M41.777 95.4309V90.2393H42.6663V94.6294H45.3096V95.4309H41.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M46.0936 95.4309V90.2393H46.9829V95.4309H46.0936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M47.6482 95.4309L49.7661 90.2393H50.6554L52.7816 95.4309H51.8626L51.3373 94.1478H49.0942L48.5688 95.4309H47.6498H47.6482ZM49.4104 93.3612H51.0178L50.2174 91.3887L49.4104 93.3612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M53.4536 95.4309V90.2393H54.417L56.9862 94.1478V90.2393H57.8755V95.4309H56.9121L54.3429 91.5223V95.4309H53.4536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M60.3623 95.4309V91.0408H58.6298V90.2393H62.9776V91.0408H61.2516V95.4309H60.3623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M45.0263 33.9519H43.7681V31.0774C43.7681 29.039 42.0767 27.3799 39.9983 27.3799C37.92 27.3799 36.2286 29.039 36.2286 31.0774V33.9519H34.9736C33.8192 33.9519 32.8788 34.892 32.8788 36.0497V43.1792C32.8788 44.3353 33.8175 45.2769 34.9736 45.2769H45.0247C46.1792 45.2769 47.1196 44.3369 47.1196 43.1792V36.0497C47.1196 34.8936 46.1808 33.9519 45.0247 33.9519H45.0263ZM37.6252 31.0774C37.6252 29.8091 38.6891 28.7784 39.9983 28.7784C41.3076 28.7784 42.3715 29.8091 42.3715 31.0774V33.9519H37.6252V31.0774ZM45.7246 43.1792C45.7246 43.5651 45.4117 43.8784 45.0263 43.8784H34.9753C34.5899 43.8784 34.277 43.5651 34.277 43.1792V36.0497C34.277 35.6638 34.5899 35.3504 34.9753 35.3504H45.0263C45.4117 35.3504 45.7246 35.6638 45.7246 36.0497V43.1792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M40 37.3774C39.2869 37.3774 38.7088 37.9563 38.7088 38.6704C38.7088 39.1272 38.9443 39.5263 39.3 39.7572V41.291C39.3 41.6769 39.613 41.9902 39.9983 41.9902C40.3837 41.9902 40.6966 41.6769 40.6966 41.291V39.7589C41.054 39.5296 41.2911 39.1272 41.2911 38.6704C41.2911 37.9563 40.7131 37.3774 40 37.3774Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 106.667,
    fill: "white",
    transform: "translate(0 0.435547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbene2);
export default __webpack_public_path__ + "static/media/ebene-2.5e9dc08fea9bc40ddff160ec921bc99f.svg";
export { ForwardRef as ReactComponent };